<template>
  <div class="title-container">
    <div class="list-number-circle">{{ `0${propsObject.sequense}` }}</div>
    <div>
      <div v-if="isFirstTitle" class="">
        <span class="option-title d-block">본부금을 얼마에</span>
        <div class="d-flex">
          <span class="option-title d-block">맞춰 볼까요?</span>
          <span v-if="propsObject.isRequired" class="required">&#42;</span>
        </div>
      </div>
      <div v-else class="d-flex">
        <span class="option-title d-block">{{ `${propsObject.title}` }}</span>
        <span v-if="propsObject.isRequired" class="required">&#42;</span>
      </div>
      <span class="first-option-description d-block">{{
        ` ${propsObject.description}`
      }}</span>
      <span
        v-if="propsObject.subDescription"
        class="sub-option-description d-block"
        >{{ propsObject.subDescription }}</span
      >
    </div>
  </div>
</template>

<script>
export default {
  name: 'claim-combination-title',
  props: {
    propsObject: {
      type: Object,
      required: true,
    },
  },
  computed: {
    isFirstTitle() {
      return this.propsObject.sequense === 1;
    },
    isSliceFirstTitle() {
      return {};
    },
  },
};
</script>

<style lang="scss" scoped>
.title-container {
  display: flex;
  max-width: 14rem;
  flex: 1;
  .list-number-circle {
    display: flex;
    font-weight: 700;
    justify-content: center;
    align-items: center;
    font-size: 0.875rem;
    color: #fff;
    width: 1.875rem;
    height: 1.5rem;
    padding: 0.375rem;
    border-radius: 1rem;
    background: #1d77ff;
    margin-right: 0.5rem;
    margin-top: 0.1875rem;
  }
  .option-title {
    font-size: 1.25rem;
    font-weight: 700;
    white-space: nowrap;
    line-height: 1.5rem;
  }
  .first-option-description {
    margin-top: 0.25rem;
  }
  .first-option-description,
  .sub-option-description {
    font-size: 0.8125rem;

    color: #94969d;
    line-height: 1rem;
  }

  .required {
    line-height: 1.5rem;

    color: #e64937;
    font-size: 1.25rem;
  }
}
</style>
